module.exports = __webpack_public_path__ + "img/icon-white-36.2dd4b43a.svg";